(function () {
  'use strict';

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- Scroll-reveal via IntersectionObserver ---
  function initReveal() {
    // Sections to fade-up
    const fadeUpSelectors = [
      '.image-with-text',
      '.icon-bar',
      '.comparison-table',
      '.rich-text',
      '.newsletter',
      '.footer',
    ];

    // Sections to stagger children
    const staggerSelectors = [
      '.testimonials .testimonials__grid',
      '.testimonials .testimonials-list',
      '.comparison-table .comparison-table__columns',
      '.icon-bar .icon-bar__grid',
      '.icon-bar__list',
    ];

    // Ticker slides in from left
    const slideLeftSelectors = ['.horizontal-ticker', '.ticker-bar'];

    if (prefersReduced) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('wly-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    fadeUpSelectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        el.classList.add('wly-reveal');
        observer.observe(el);
      });
    });

    staggerSelectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        el.classList.add('wly-reveal-stagger');
        observer.observe(el);
      });
    });

    slideLeftSelectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        el.classList.add('wly-reveal-left');
        observer.observe(el);
      });
    });
  }

  // --- Parallax on ingredient story + flatlay sections ---
  function initParallax() {
    if (prefersReduced) return;

    // Target the two new product image sections
    const parallaxSections = [
      '#shopify-section-ingredient_story_section',
      '#shopify-section-flatlay_lifestyle_section',
    ];

    const targets = [];
    parallaxSections.forEach((sel) => {
      const section = document.querySelector(sel);
      if (!section) return;
      const img = section.querySelector('.image-with-text__media, .image-with-text__image-container');
      if (!img) return;
      img.classList.add('wly-parallax-wrap');
      const inner = img.querySelector('img, .wly-parallax-img');
      if (inner) {
        inner.classList.add('wly-parallax-img');
        targets.push({ section, inner });
      }
    });

    if (!targets.length) return;

    let ticking = false;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          targets.forEach(({ section, inner }) => {
            const rect = section.getBoundingClientRect();
            const vh = window.innerHeight;
            // Only parallax when section is visible
            if (rect.bottom < 0 || rect.top > vh) return;
            const progress = (vh - rect.top) / (vh + rect.height); // 0→1 as it scrolls through
            const shift = (progress - 0.5) * 60; // ±30px range
            inner.style.transform = `translateY(${shift.toFixed(1)}px)`;
          });
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // init
  }

  // --- Run after DOM ready ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { initReveal(); initParallax(); });
  } else {
    initReveal();
    initParallax();
  }
})();
